export default {
  // ページタイトル
  title: 'アクティビティ一覧',
  // トップ操作
  addActivity: 'アクティビティを追加',
  sortLevelTooltip:
    '優先度説明：数字が大きいほど優先度が高くなります。QRコードが複数のアクティビティに含まれる場合、消費者は優先度の高いアクティビティに優先的に入ります。',
  // 検索エリア
  activityName: 'アクティビティ名',
  activityNamePlaceholder: 'アクティビティ名を入力してください',
  activityId: 'アクティビティID',
  activityIdPlaceholder: 'アクティビティIDを入力してください',
  activityNo: 'アクティビティ番号',
  activityNoPlaceholder: 'アクティビティ番号を入力してください',
  activityStatus: 'アクティビティステータス',
  activityStatusPlaceholder: 'すべて',
  search: '検索',
  reset: 'リセット',
  // ステータス
  statusAll: 'すべて',
  statusNotStarted: '未開始',
  statusActive: '進行中',
  statusEnded: '終了',
  statusDisabled: '無効',
  // テーブル列
  colActivityId: 'アクティビティID',
  colActivityCode: 'アクティビティコード',
  colActivityName: 'アクティビティ名',
  colActivityTime: 'アクティビティ時間',
  colStatus: 'ステータス',
  colSortLevel: '優先度',
  colRemark: 'アクティビティ備考',
  colCreateTime: '作成時間',
  colAction: '操作',
  // 操作
  actions: '操作',
  detail: '詳細',
  edit: '編集',
  disable: '無効化',
  enable: '有効化',
  delete: '削除',
  // 時間範囲
  timeRangeSep: 'から',
  // ソート編集
  sortLevelPlaceholder: 'ソート値を入力してください',
  // 確認ポップアップ
  confirmDeleteTitle: '削除の確認',
  confirmDeleteContent: 'このアクティビティを削除してもよろしいですか？削除すると元に戻せません。',
  confirmToggleTitle: '操作の確認',
  confirmDisableContent: 'このアクティビティを無効化してもよろしいですか？',
  confirmEnableContent: 'このアクティビティを有効化してもよろしいですか？',
  // 空状態
  emptyText: 'アクティビティデータがありません',
};
